// modulo  paginator
// https://github.com/cornflourblue/react-pagination-example
// Css bootstrap https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css
import React from 'react';

class BannerBlock extends React.Component {

    constructor(props) {
        super(props);
        this.state = { };

    }
    componentDidMount() { }
    render() {

        return (
            <div id={'banner-block-wrap'}>
                <div id={'banner-block'} >

                    <img className={'image-head'}
                         src={ this.props.urlImage }/>  
                    <p className={'text-body'}> { this.props.testo } </p>
                    <a href={this.props.pageurl} className={'btn-confronta'}>Scopri</a>
                </div>
            </div>
        );
    }
}

export default BannerBlock;